// extracted by mini-css-extract-plugin
export default {"termsAndConditions":"uybgBcKl_C8oBCk4zk4C","termsLink":"tkxh9u_g849MfAJa5LPC","submitButton":"ZNyB4coaWw5YsNZVEwLR","fadeIn":"wKeIcrW6q8kiHOrVVbV6"};